import React from "react";

const TermsAndConditions: React.FC = () => {
  return (
    <div className="bg-gray-50 font-poppins">
      <div className="container mx-auto px-4 py-12">
        <div className="bg-white p-10 rounded-xl shadow-lg">
          <h1 className="text-4xl font-bold mb-8 text-gray-900 border-b pb-4">
            Terms and Conditions
          </h1>

          <div className="space-y-8 text-gray-700">
            <div className="space-y-4">
              <h2 className="text-2xl font-semibold text-gray-800">
                Table of Contents
              </h2>
              <ul className="list-disc list-inside space-y-2 pl-4">
                <li>
                  <a href="#welcome" className="hover:underline text-primary-600">
                    Welcome to Envolvly!
                  </a>
                </li>
                <li>
                  <a href="#account" className="hover:underline text-primary-600">
                    Your Account
                  </a>
                </li>
                <li>
                  <a href="#using" className="hover:underline text-primary-600">
                    Using Envolvly
                  </a>
                </li>
                <li>
                  <a href="#ownership" className="hover:underline text-primary-600">
                    Ownership
                  </a>
                </li>
                <li>
                  <a href="#fees" className="hover:underline text-primary-600">
                    Fees & Payment
                  </a>
                </li>
                <li>
                  <a href="#third-party" className="hover:underline text-primary-600">
                    Third-Party Content
                  </a>
                </li>
                <li>
                  <a href="#restrictions" className="hover:underline text-primary-600">
                    Restrictions
                  </a>
                </li>
                <li>
                  <a href="#changes" className="hover:underline text-primary-600">
                    Term Changes
                  </a>
                </li>
              </ul>
            </div>

            <div id="welcome" className="space-y-4">
              <h2 className="text-2xl font-semibold text-gray-800">
                Welcome to Envolvly!
              </h2>
              <p>
                By using Envolvly (referred to as “Envolvly”, “we”, “us”, or
                “our"), you agree to these terms and to the other policies we
                list, including the Privacy Policy, Community Guidelines, and
                Benefit Guidelines.
              </p>
            </div>

            <div id="account" className="space-y-4">
              <h2 className="text-2xl font-semibold text-gray-800">
                Your Account
              </h2>
              <p>
                A. You must be at least 13 years old to use Envolvly. You must
                be at least 18 years old or have your parent’s or legal
                guardian’s permission if you want to own a creator page or
                perform any transactions offered on Envolvly. You are
                responsible for everything that occurs when your account is
                signed in. You are responsible for the security of the account.
              </p>
              <p>
                B. You may terminate your account at any time through your
                account settings. We may keep certain information as required by
                law or as necessary for our legitimate business purposes.
                Deleting your account will remove all your content from the
                website unless preserved for other purposes, which we reserve
                the right to do.
              </p>
              <p>
                C. We reserve the right to terminate access to our Site to any
                person at any time, for any reason, in our sole discretion. If
                you violate these Terms, your permission to use Envolvly
                automatically terminates.
              </p>
            </div>

            <div id="using" className="space-y-4">
              <h2 className="text-2xl font-semibold text-gray-800">
                Using Envolvly
              </h2>
              <p>
                By creating an account on our Site, you agree to provide true,
                accurate, current, and complete information. You agree not to
                create a Site account using a false identity or providing false
                information or if you have previously been removed or banned
                from our Site. You are responsible for maintaining the
                confidentiality of your Site account information, including your
                username and password. You are responsible for all activities
                that occur on or in connection with your Site account and you
                agree to notify us immediately of any unauthorized access or use
                of your Site account. You acknowledge and agree that we are not
                responsible or liable for any damages, losses, costs, expenses,
                or liabilities related to any unauthorized access to or use of
                your Site account.
              </p>
            </div>

            <div id="ownership" className="space-y-4">
              <h2 className="text-2xl font-semibold text-gray-800">
                Ownership
              </h2>
              <p>
                Creators keep full ownership of their Envolvly creations, and
                purchasers retain full ownership of anything they post. However,
                by sharing your creations or posting on Envolvly, you grant us a
                royalty-free, perpetual, irrevocable, non-exclusive,
                sublicensable, worldwide license to use, copy, reproduce, store,
                translate, transmit, distribute, perform, adapt, publicly
                display, and display your content—along with any name, username,
                voice, or likeness provided—in all formats and channels now
                known or developed in the future. To be clear, you always
                maintain full ownership of your creations and posts; we do not
                purchase or lease your intellectual property. We will never
                attempt to take, exploit, or profit from your creations beyond
                what’s necessary to operate Envolvly and facilitate the
                memberships and offerings you’ve set up.
              </p>
            </div>

            <div id="fees" className="space-y-4">
              <h2 className="text-2xl font-semibold text-gray-800">
                Fees & Payment
              </h2>
              <p>
                There are fees associated with your offerings and paid
                transactions on Envolvly. Creating an account on Envolvly is
                free, however we collect a 15% fee on all transactions that
                occur on the website, along with fee that our payment processors
                may collect. Our processing partners’ fees may vary slightly
                based on your location. You’re responsible for paying any
                additional fees or taxes associated with your use of Envolvly.
              </p>
            </div>

            <div id="third-party" className="space-y-4">
              <h2 className="text-2xl font-semibold text-gray-800">
                Third-Party Content
              </h2>
              <p>
                Creators will often feature content on their pages that will link
                to or provide you with access to third-party content, that is
                completely independent of Envolvly, including websites,
                platforms, directories, servers, networks, systems, information,
                databases, applications, software, programs, products or
                services, and the Internet in general. The contents of such
                third-parties are the sole responsibility of the people involved
                in those interactions. Envolvly is not responsible for the
                content of the interactions you may have with third parties. You
                acknowledge and agree that Envolvly is not responsible or liable
                for any damages, losses, costs, expenses, or liabilities of any
                kind or nature incurred as the result of any harmful
                interactions that occur outside the facilitation of our Service.
              </p>
            </div>

            <div id="restrictions" className="space-y-4">
              <h2 className="text-2xl font-semibold text-gray-800">
                Restrictions
              </h2>
              <p>
                We reserve the right to remove content that we have identified
                as violating to our terms or policies. These policies are
                outlined in detail through our Community Guidelines. A summary of
                those rules is that we don’t allow:
              </p>
              <ul className="list-decimal list-inside space-y-2 pl-4">
                <li>Illegal offerings.</li>
                <li>
                  Envolvments or offerings that are abusive towards other
                  people.
                </li>
                <li>
                  Envolvments or offerings that are misleading or deceptive.
                </li>
                <li>
                  Envolvments or offerings that use others’ intellectual
                  property, unless you have written permission to use it, or
                  your use is protected as fair use.
                </li>
                <li>Envolvments or offerings engaging in sexual acts.</li>
              </ul>
              <p>
                We are not required to allow any particular person or group of
                persons to access an offering. We are constantly experimenting
                with product features to improve Envolvly. Access to these
                features is not guaranteed and may not be subject to your
                control.We may enable and disable these early-access, beta, or
                test features at our sole discretion. These features may also be
                subject to additional restrictions and limitations.
              </p>
            </div>

            <div id="changes" className="space-y-4">
              <h2 className="text-2xl font-semibold text-gray-800">
                Term Changes
              </h2>
              <p>
                We reserve the right to modify or update these Terms and
                Conditions at any given time. The amended Terms will come into
                effect immediately upon your acceptance, a process that is
                generally prompted during the sign-up or purchase transaction.
                In the event that you do not explicitly accept the revised Terms
                at the time of the transaction, the updated Terms will
                automatically become effective 30 days after being posted on our
                platform.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;